module.exports = __webpack_public_path__ + "img/help-center.201f573c.svg";